import React from 'react';
import SSOAuth from './shared/SSOAuth';
import HRDashboard from './components/HRDashboard';
import './App.css';

function App() {
  return (
    <SSOAuth>
      <div className="App">
        <HRDashboard />
      </div>
    </SSOAuth>
  );
}

export default App;
